import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Header/Header1";
import Footer from "../Footer/footer";
import "./Assets.scss";
import Sidebar from "../SideBar/SideBar";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
} from "@mui/material";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import zec from "../../Img/coins/zec.png";
import xec from "../../Img/coins/xec.png";
import kcs from "../../Img/coins/kcs.png";
import scr from "../../Img/coins/scr.png";
import cat from "../../Img/coins/cat.png";
import woop from "../../Img/coins/woop.png";
import pip from "../../Img/coins/pip.png";
import insp from "../../Img/coins/xec.png";
import ese from "../../Img/coins/ese.png";
import sol from "../../Img/coins/sol.png";
import eye from "../../Img/eye.svg";
import eye_hide from "../../Img/eye_hide.svg";
import reward from "../../Img/reward.webp";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";
import { toast, ToastContainer } from "react-toastify";
import { Code } from "../../SvgCollection";
import Loader from "../Loader";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function Referral() {
  const [age, setAge] = useState("");

  const handleSelectChange = (event) => {
    setAge(event.target.value);
  };
  const [hideZero, setHideZero] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(5); // Rows per page

  const [imghide, setimghide] = useState([
    { show: true },
    { show: false },
    { show: true },
  ]);

  const assetData = [
    {
      title: "Referral Assets",
      balance: "0.0000",
      depositLink: "#",
      withdrawLink: "#",
      convertLink: "#",
    },
  ];

  const showimg = (i) => {
    setimghide((prevData) =>
      prevData.map((item, index) =>
        index === i ? { ...item, show: !item.show } : item
      )
    );
  };

  const data = [
    {
      id: "14:25 PM",
      currencyName: "5635863563",
      currencySymbol: "Sign Up Bonus",
      availableBalance: 0.0,
      icon: zec,
    },
    {
      id: "14:25 PM",
      currencyName: "5635863563",
      currencySymbol: "Sign Up Bonus",
      availableBalance: 0.0,
      icon: xec,
    },
    {
      id: "14:25 PM",
      currencyName: "5635863563",
      currencySymbol: "Sign Up Bonus",
      availableBalance: 0.0,
      icon: kcs,
    },
    {
      id: "14:25 PM",
      currencyName: "5635863563",
      currencySymbol: "Sign Up Bonus",
      availableBalance: 0.0,
      icon: scr,
    },
    {
      id: "14:25 PM",
      currencyName: "5635863563",
      currencySymbol: "Sign Up Bonus",
      availableBalance: 0.0,
      icon: cat,
    },
    {
      id: "14:25 PM",
      currencyName: "5635863563",
      currencySymbol: "Sign Up Bonus",
      availableBalance: 0.0,
      icon: woop,
    },
    {
      id: "14:25 PM",
      currencyName: "5635863563",
      currencySymbol: "Sign Up Bonus",
      availableBalance: 0.0,
      icon: pip,
    },
    {
      id: "14:25 PM",
      currencyName: "5635863563",
      currencySymbol: "Sign Up Bonus",
      availableBalance: 0.0,
      icon: insp,
    },
    {
      id: "14:25 PM",
      currencyName: "5635863563",
      currencySymbol: "Sign Up Bonus",
      availableBalance: 0.0,
      icon: ese,
    },
    {
      id: "14:25 PM",
      currencyName: "5635863563",
      currencySymbol: "Sign Up Bonus",
      availableBalance: 0.0,
      icon: sol,
    },
  ];

  const filteredData = data.filter((row) => {
    const matchesSearch = row.currencyName
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const hasBalance = hideZero ? row.availableBalance > 0 : true;
    return matchesSearch && hasBalance;
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page when rows per page changes
  };

  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const options = {
    loop: false,
    nav: false,
    dots: false,
    items: 1,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
  };

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [account, setAccount] = useState("QBAD19AZ");
  const handleCopyAcc = () => {
    navigator.clipboard.writeText(account).then(() => {
      return toast.success("Code Copied");
    });
  };

  const [bankName, setBankName] = useState(
    "https://www.Dreamster-Excoin.com/r/rf/QBAD19AZ"
  );
  const handleCopyName = () => {
    navigator.clipboard.writeText(bankName).then(() => {
      return toast.success("Link Copied");
    });
  };

  return (
    <div className="spot-full menu-responsive">
      <div>
        <Header />
        <Loader />
        <ToastContainer />
        <div className="main_flx">
          <Sidebar />
          <div className="dash_board">
            <div className="abvbar split_half display-2 flex-wrap">
              <h6>Referral</h6>
            </div>

            <div className="crypto-inr split_half">
              <div className="mb-4">
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={12} md={12} lg={9} xl={9}>
                        {assetData.map((row, i) => (
                          <div className="asset_box box_bdr display-2">
                            <div>
                              <p
                                className={` ${
                                  imghide[i].show ? "show" : "hide"
                                }`}
                              >
                                {row.title}
                                <span
                                  className="cusrsor-pointer"
                                  onClick={() => showimg(i)}
                                >
                                  {imghide[i]?.show ? (
                                    <img src={eye} alt="img" />
                                  ) : (
                                    <img src={eye_hide} alt="img" />
                                  )}
                                </span>
                              </p>
                              <div className="display-1 select-col">
                                <h2>
                                  {imghide[i].show ? row.balance : "*****"} USDT{" "}
                                </h2>
                                <div className="usdt-select">
                                  <FormControl fullWidth>
                                    <NativeSelect
                                      defaultValue={30}
                                      inputProps={{
                                        name: "age",
                                        id: "uncontrolled-native",
                                      }}
                                    >
                                      <option value={10}>Ten</option>
                                      <option value={20}>Twenty</option>
                                      <option value={30}>Thirty</option>
                                    </NativeSelect>
                                  </FormControl>
                                </div>
                              </div>

                              <div className="flx mt-40">
                                {row.withdrawLink && (
                                  <Link
                                    to={row.withdrawLink}
                                    className="org_btn radius"
                                  >
                                    Withdraw
                                  </Link>
                                )}
                                {row.convertLink && (
                                  <Link
                                    to={row.convertLink}
                                    className="bdr_btn radius"
                                  >
                                    Transfer
                                  </Link>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                        <div className="asset_box box_bdr referral-count">
                          <p>Referral Count</p>
                          <h3>5</h3>
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <div className="note-col text-center">
                          <span>
                            Note: You can withdraw your referral bonus only for
                            verified Users
                          </span>
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <div className="asset_box box_bdr refer-frnd">
                          <h6 className="text-center">
                            Refer a Friend and Get <span>2 USDT</span>
                          </h6>
                          <div className="referal-code-copy">
                            <div className="display-2 refer-code">
                              <p>Referral Code</p>
                              <div className="display-1 copy-txt">
                                <div> {account} </div>
                                <div
                                  className="d-flex"
                                  onClick={() => handleCopyAcc()}
                                >
                                  <Code />
                                </div>
                              </div>
                            </div>
                            <div className="display-2 refer-code">
                              <p>Referral Link</p>
                              <div className="display-1 copy-txt">
                                <div className="link-text"> {bankName} </div>
                                <div
                                  className="d-flex"
                                  onClick={() => handleCopyName()}
                                >
                                  <Code />
                                </div>
                              </div>
                            </div>
                            <div className="common-btn deposit-submit mt-20 invite-btn">
                              <Button>Invite Now</Button>
                            </div>
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <div className="custom_acc box_bdr">
                      <h5>FAQ</h5>
                      <Accordion>
                        <AccordionSummary
                          expandIcon={
                            <svg
                              width="21"
                              height="22"
                              viewBox="0 0 21 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M11.0332 7.4681C11.0332 7.00786 10.6601 6.63477 10.1999 6.63477C9.73963 6.63477 9.36654 7.00786 9.36654 7.4681V9.9681H6.86654C6.4063 9.9681 6.0332 10.3412 6.0332 10.8015C6.0332 11.2617 6.4063 11.6348 6.86654 11.6348H9.36654V14.1348C9.36654 14.595 9.73963 14.9681 10.1999 14.9681C10.6601 14.9681 11.0332 14.595 11.0332 14.1348V11.6348H13.5332C13.9934 11.6348 14.3665 11.2617 14.3665 10.8015C14.3665 10.3412 13.9934 9.9681 13.5332 9.9681H11.0332V7.4681Z"
                                fill="#8C8C8C"
                                fill-opacity="0.4"
                              />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M10.1999 1.63477C5.13713 1.63477 1.0332 5.7387 1.0332 10.8015C1.0332 15.8642 5.13713 19.9681 10.1999 19.9681C15.2626 19.9681 19.3665 15.8642 19.3665 10.8015C19.3665 5.7387 15.2626 1.63477 10.1999 1.63477ZM2.69987 10.8015C2.69987 6.65917 6.05761 3.30143 10.1999 3.30143C14.3421 3.30143 17.6999 6.65917 17.6999 10.8015C17.6999 14.9437 14.3421 18.3015 10.1999 18.3015C6.05761 18.3015 2.69987 14.9437 2.69987 10.8015Z"
                                fill="#8C8C8C"
                                fill-opacity="0.4"
                              />
                            </svg>
                          }
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Typography>
                            What is Identity Verification?
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography>
                            Identity Verification (KYC) is a process where
                            Dreamster-Exchange verifies your identity through
                            personal documents. It's required to access features
                            like withdrawals and rewards.
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                      <Accordion>
                        <AccordionSummary
                          expandIcon={
                            <svg
                              width="21"
                              height="22"
                              viewBox="0 0 21 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M11.0332 7.4681C11.0332 7.00786 10.6601 6.63477 10.1999 6.63477C9.73963 6.63477 9.36654 7.00786 9.36654 7.4681V9.9681H6.86654C6.4063 9.9681 6.0332 10.3412 6.0332 10.8015C6.0332 11.2617 6.4063 11.6348 6.86654 11.6348H9.36654V14.1348C9.36654 14.595 9.73963 14.9681 10.1999 14.9681C10.6601 14.9681 11.0332 14.595 11.0332 14.1348V11.6348H13.5332C13.9934 11.6348 14.3665 11.2617 14.3665 10.8015C14.3665 10.3412 13.9934 9.9681 13.5332 9.9681H11.0332V7.4681Z"
                                fill="#8C8C8C"
                                fill-opacity="0.4"
                              />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M10.1999 1.63477C5.13713 1.63477 1.0332 5.7387 1.0332 10.8015C1.0332 15.8642 5.13713 19.9681 10.1999 19.9681C15.2626 19.9681 19.3665 15.8642 19.3665 10.8015C19.3665 5.7387 15.2626 1.63477 10.1999 1.63477ZM2.69987 10.8015C2.69987 6.65917 6.05761 3.30143 10.1999 3.30143C14.3421 3.30143 17.6999 6.65917 17.6999 10.8015C17.6999 14.9437 14.3421 18.3015 10.1999 18.3015C6.05761 18.3015 2.69987 14.9437 2.69987 10.8015Z"
                                fill="#8C8C8C"
                                fill-opacity="0.4"
                              />
                            </svg>
                          }
                          aria-controls="panel2a-content"
                          id="panel2a-header"
                        >
                          <Typography>
                            Why do I need to complete Identity Verification?
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography>
                            Identity Verification is required to comply with
                            regulations, enhance account security, and unlock
                            key features like withdrawals, bonuses, and rewards.
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                      <Accordion>
                        <AccordionSummary
                          expandIcon={
                            <svg
                              width="21"
                              height="22"
                              viewBox="0 0 21 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M11.0332 7.4681C11.0332 7.00786 10.6601 6.63477 10.1999 6.63477C9.73963 6.63477 9.36654 7.00786 9.36654 7.4681V9.9681H6.86654C6.4063 9.9681 6.0332 10.3412 6.0332 10.8015C6.0332 11.2617 6.4063 11.6348 6.86654 11.6348H9.36654V14.1348C9.36654 14.595 9.73963 14.9681 10.1999 14.9681C10.6601 14.9681 11.0332 14.595 11.0332 14.1348V11.6348H13.5332C13.9934 11.6348 14.3665 11.2617 14.3665 10.8015C14.3665 10.3412 13.9934 9.9681 13.5332 9.9681H11.0332V7.4681Z"
                                fill="#8C8C8C"
                                fill-opacity="0.4"
                              />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M10.1999 1.63477C5.13713 1.63477 1.0332 5.7387 1.0332 10.8015C1.0332 15.8642 5.13713 19.9681 10.1999 19.9681C15.2626 19.9681 19.3665 15.8642 19.3665 10.8015C19.3665 5.7387 15.2626 1.63477 10.1999 1.63477ZM2.69987 10.8015C2.69987 6.65917 6.05761 3.30143 10.1999 3.30143C14.3421 3.30143 17.6999 6.65917 17.6999 10.8015C17.6999 14.9437 14.3421 18.3015 10.1999 18.3015C6.05761 18.3015 2.69987 14.9437 2.69987 10.8015Z"
                                fill="#8C8C8C"
                                fill-opacity="0.4"
                              />
                            </svg>
                          }
                          aria-controls="panel3a-content"
                          id="panel3a-header"
                        >
                          <Typography>
                            Which documents and information are required for
                            Identity Verification?
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography>
                            For Identity Verification, you'll need to provide a
                            valid government-issued ID (National ID), proof of
                            address, and a selfie to confirm your identity.
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                      <Accordion>
                        <AccordionSummary
                          expandIcon={
                            <svg
                              width="21"
                              height="22"
                              viewBox="0 0 21 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M11.0332 7.4681C11.0332 7.00786 10.6601 6.63477 10.1999 6.63477C9.73963 6.63477 9.36654 7.00786 9.36654 7.4681V9.9681H6.86654C6.4063 9.9681 6.0332 10.3412 6.0332 10.8015C6.0332 11.2617 6.4063 11.6348 6.86654 11.6348H9.36654V14.1348C9.36654 14.595 9.73963 14.9681 10.1999 14.9681C10.6601 14.9681 11.0332 14.595 11.0332 14.1348V11.6348H13.5332C13.9934 11.6348 14.3665 11.2617 14.3665 10.8015C14.3665 10.3412 13.9934 9.9681 13.5332 9.9681H11.0332V7.4681Z"
                                fill="#8C8C8C"
                                fill-opacity="0.4"
                              />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M10.1999 1.63477C5.13713 1.63477 1.0332 5.7387 1.0332 10.8015C1.0332 15.8642 5.13713 19.9681 10.1999 19.9681C15.2626 19.9681 19.3665 15.8642 19.3665 10.8015C19.3665 5.7387 15.2626 1.63477 10.1999 1.63477ZM2.69987 10.8015C2.69987 6.65917 6.05761 3.30143 10.1999 3.30143C14.3421 3.30143 17.6999 6.65917 17.6999 10.8015C17.6999 14.9437 14.3421 18.3015 10.1999 18.3015C6.05761 18.3015 2.69987 14.9437 2.69987 10.8015Z"
                                fill="#8C8C8C"
                                fill-opacity="0.4"
                              />
                            </svg>
                          }
                          aria-controls="panel4a-content"
                          id="panel4a-header"
                        >
                          <Typography>
                            Where can I find help for issues regarding Identity
                            Verification?
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography>
                            You can find help in the 'Support' section of
                            Dreamster-Exchange or contact customer service
                            directly for assistance with any Identity
                            Verification issues.
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                    </div>
                    <div className="custom_acc box_bdr mt-30">
                      <h5>Begin your Crypto exploration Now!</h5>
                      <div className="mt-20 scan-qr">
                        <Link to="" className="display-1">
                          Scan to Download <QrCode2Icon />
                        </Link>
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className="mt-50">
                      <h2>Recent Rewards</h2>
                    </div>
                    <div className="custom_table box_bdr">
                      <TableContainer sx={{ marginBottom: "10px" }}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              <TableCell>Name</TableCell>
                              <TableCell>User ID</TableCell>
                              <TableCell>Amount</TableCell>
                              <TableCell>KYC Status</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {paginatedData.map((row) => (
                              <TableRow key={row.id} className="tr_row">
                                <TableCell>{row.id}</TableCell>
                                <TableCell>{row.currencyName}</TableCell>
                                <TableCell>{row.currencySymbol}</TableCell>
                                <TableCell>{row.availableBalance}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                        <TablePagination
                          rowsPerPageOptions={[5, 10, 15]} // Options for rows per page
                          component="div"
                          count={filteredData.length} // Total number of filtered rows
                          rowsPerPage={rowsPerPage}
                          page={page}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                      </TableContainer>
                    </div>
                  </Grid>
                </Grid>
              </div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
}
